import "./featuredWork.styles.scss";

const projects = [
  {
    id: 1,
    number: "01",
    title: "Mind Threads",
    description:
      "Minimalist productivity tool designed to visualize thoughts as evolving “threads.” Each thread represents a topic or problem and grows vertically through connected updates, creating timeline style log.",
    tech: ["React", "Next.js"],
    category: "Web App",
    url: "https://mind-threads.netlify.app/",
  },
  {
    id: 2,
    number: "02",
    title: "Glosi",
    description:
      "English glossary to capture, understand and organize English vocabulary. It supports adding new words, selecting definitions from a dictionary API, writing custom explanations and classifying terms under personalizeds labels.",
    tech: ["React", "Next.js", "NextAuth.js", "Google OAuth", "Prisma"],
    category: "Web Game",
    url: "https://glosi.vercel.app/",
  },
  {
    id: 3,
    number: "03",
    title: "Game Pulse Frontend",
    description:
      "Data aggregation platform that tracks real-time analytics for trending videogames using live data from platforms like SteamCharts and Steam API.",
    tech: [
      "React",
      "Next.js",
      "TypeScript",
      "Tailwind",
      "Recharts",
      "Web scraping",
    ],
    category: "Web App",
    url: "https://game-pulse-blush.vercel.app/",
    inProgress: true,
  },
  {
    id: 4,
    number: "04",
    title: "Game Pulse Backend",
    description:
      "Comprehensive component library with Storybook documentation and design tokens for consistent UI.",
    tech: ["Python", "FastAPI", "Uvicorn", "SQLModel", "PostgreSQL", "Alembic"],
    category: "Backend",
    url: "https://github.com/ann-jrti/game-pulse",
    inProgress: true,
  },
];

export const FeaturedWork = () => {
  return (
    <section className="featured" id="featured">
      <div className="featured__bg">
        <div className="featured__grain"></div>
      </div>

      <div className="featured__container">
        <div className="featured__header">
          <div className="featured__intro">
            <span className="featured__label">selected work</span>
            <div className="featured__line"></div>
          </div>

          <div className="featured__title-row">
            <h2 className="featured__title">
              <span className="featured__title-line">featured</span>
              <span className="featured__title-line">
                <span className="featured__outline">projects</span>
              </span>
            </h2>
          </div>
        </div>

        <div className="featured__list">
          {projects.map((project) => (
            <article key={project.id} className="project">
              <div className="project__header">
                <span className="project__number">{project.number}</span>
                <span className="project__meta">
                  <span className="project__category">{project.category}</span>
                </span>
              </div>

              <div className="project__content">
                <h3 className="project__title">{project.title}</h3>
                {project.inProgress && (
                  <span className="project__in-progress">work in progress</span>
                )}
                <p className="project__description">{project.description}</p>
              </div>

              <div className="project__footer">
                <div className="project__tech">
                  {project.tech.map((tech, index) => (
                    <span key={index} className="project__tag">
                      {tech}
                    </span>
                  ))}
                </div>

                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project__link"
                >
                  <span>View Project</span>
                  <svg
                    className="project__arrow"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M7 17L17 7M17 7H7M17 7V17" />
                  </svg>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
